module.exports = ".error-block{\n    height: 500px;\n    text-align: center!important;\n    vertical-align: middle;\n    font-size: 24px;\n    line-height: 50px;\n    padding: 300px 0;\n}\n\n.error-msg-mail-style {\n    color: blue;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error-view/error-view.component.css
// module id = ./src/app/components/error-view/error-view.component.css
// module chunks = main